import { auto } from "../enums.js";
export default function getBasePlacement(placement) {
  return placement.split('-')[0];
}


//////////////////
// WEBPACK FOOTER
// ./~/@popperjs/core/lib/utils/getBasePlacement.js
// module id = 72
// module chunks = 93